import { Action } from 'redux'
import User from '../../interfaces/User'

const UserActions = {
    LOGIN: 'LOGIN',
    SET_USER: 'SET_USER',
    CLEAR_USER: 'CLEAR_USER'
}

export interface LoginUserAction extends Action {
    login: string
    password: string
}

export interface SetUserAction extends Action {
    user: User
}

export default UserActions
